import axios, { AxiosError, AxiosRequestConfig } from 'axios'
import { queryClient } from '../queries/client'
import { investorApi } from './investorApi'
import { refetchAccessToken } from './authentication'

const idServerApi = axios.create({
  baseURL: process.env.REACT_APP_ID_SERVER_URL ?? 'https://dev-identity-api.hissa.com/v1/',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

interface ExtendedAxiosRequestConfig extends AxiosRequestConfig {
  _retry?: boolean
}

let isRefreshing = false
let refreshSubscribers: ((token: string) => void)[] = []

function onTokenRefreshed(token: string) {
  refreshSubscribers.forEach((callback) => callback(token))
  refreshSubscribers = []
}

function addRefreshSubscriber(callback: (token: string) => void) {
  refreshSubscribers.push(callback)
}

investorApi.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as ExtendedAxiosRequestConfig
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      if (!isRefreshing) {
        isRefreshing = true
        try {
          const newToken = await refetchAccessToken();
          sessionStorage.setItem('accessToken', newToken.data)
          onTokenRefreshed(newToken.data)
          isRefreshing = false
          return investorApi(originalRequest)
        } catch (refreshError) {
          isRefreshing = false
          queryClient.clear()
          if (refreshError instanceof Error) {
            return Promise.reject(refreshError)
          } else return Promise.reject(new Error('Unknown refresh error'))
        }
      }

      return new Promise((resolve) => {
        addRefreshSubscriber((token) => {
          if (originalRequest?.headers) {
            originalRequest.headers.Authorization = `${token}`
          }
          resolve(investorApi(originalRequest))
        })
      })
    }

    return Promise.reject(error)
  }
)

export default idServerApi
